import localFont from "next/font/local";
import { brandMarkElements } from "./brand-mark";

const wordmarkFont = localFont({
  src: "./fonts/zen-maru-gothic-tamariba-700.woff2",
  weight: "700",
  style: "normal",
  display: "swap",
  preload: true,
  adjustFontFallback: false,
  fallback: ["sans-serif"],
});

export function BrandContent() {
  return (
    <>
      <svg
        className="brand-mark"
        viewBox="0 0 32 32"
        aria-hidden="true"
        focusable="false"
      >
        {brandMarkElements()}
      </svg>
      <span className={`brand-name ${wordmarkFont.className}`}>タマリバ</span>
    </>
  );
}

export function Brand({ href = "/" }: { href?: string }) {
  return (
    <a
      href={href}
      className="brand"
      aria-label={href === "/admin" ? "タマリバ 運営管理" : "タマリバ ホーム"}
    >
      <BrandContent />
    </a>
  );
}
